export const OPERATING_STYLES = [
  {
    id: "passive",
    title: "Passive",
    description: "Strong returns with minimal day-to-day involvement",
    examples: "Long leases, supported living, FRI structures",
  },
  {
    id: "active",
    title: "Active",
    description: "Happy sourcing, improving and managing assets without it becoming a second job",
    examples: "HMOs, BRRR, smaller refurbs",
  },
  {
    id: "operational",
    title: "Operational",
    description: "Comfortable running a business on top of property",
    examples: "Serviced accommodation, co-work, hospitality-style models",
  },
  {
    id: "heavy-execution",
    title: "Heavy Execution",
    description: "Happy with complexity, projects, planning and value creation",
    examples: "Conversions, larger refurbs, commercial repositioning",
  },
]

const LEGACY_OPERATING_STYLES = {
  "light-active": "active",
  "high-operational": "operational",
}

export const INVESTMENT_STRATEGIES = [
  {
    id: "brrr",
    title: "Buy, Refurbish, Refinance (BRRR)",
    shortTitle: "BRRR",
    subtitle: "Recycle capital through forced appreciation and long-term rental",
    details: ["Add value through refurbishment", "Refinance to extract capital", "Build portfolio over time"],
    stats: {
      cashflow: "Low",
      equity: "High",
      complexity: "Medium",
      builderHeavy: "Yes",
      speed: "Slow",
      bestFitStyle: "active",
    },
  },
  {
    id: "hmo",
    title: "HMOs",
    shortTitle: "HMOs",
    subtitle: "Maximise rental income through multi-tenant properties",
    details: ["High income per property", "Strong demand in key areas", "Scalable room-by-room model"],
    stats: {
      cashflow: "High",
      equity: "Medium",
      complexity: "Medium",
      builderHeavy: "Yes",
      speed: "Medium",
      bestFitStyle: "active",
    },
  },
  {
    id: "pure-commercial",
    title: "Pure Commercial",
    shortTitle: "Pure Commercial",
    subtitle: "Generate stable income through commercial leases and tenants",
    details: ["Long-term lease agreements", "Lower day-to-day involvement", "Predictable income streams"],
    stats: {
      cashflow: "Low",
      equity: "Low",
      complexity: "Low",
      builderHeavy: "No",
      speed: "Slow",
      bestFitStyle: "passive",
    },
  },
  {
    id: "urban-goldmine",
    title: "Urban Goldmine (Mixed-Use / Repositioning)",
    shortTitle: "Urban Goldmine",
    subtitle: "Unlock hidden value through creative repositioning and structuring",
    details: ["Multiple value-add angles", "Less competition in the market", "Balanced cashflow and upside"],
    stats: {
      cashflow: "Medium",
      equity: "Medium",
      complexity: "Medium",
      builderHeavy: "No",
      speed: "Medium",
      bestFitStyle: "active",
    },
  },
  {
    id: "sa",
    title: "Serviced Accommodation",
    shortTitle: "Serviced Accommodation",
    subtitle: "Short-term rentals generating higher income through nightly stays",
    details: ["Higher income potential", "Flexible pricing model", "Suitable for high-demand locations"],
    stats: {
      cashflow: "High",
      equity: "Medium",
      complexity: "High",
      builderHeavy: "No",
      speed: "Fast",
      bestFitStyle: "operational",
    },
  },
  {
    id: "cowork-serviced-office",
    title: "Co-work / Serviced Office",
    shortTitle: "Co-work / Serviced Office",
    subtitle: "Operational workspace income through serviced office demand",
    details: ["Operational commercial income", "Flexible tenant mix", "Useful in strong business locations"],
    stats: {
      cashflow: "High",
      equity: "Medium",
      complexity: "Medium",
      builderHeavy: "No",
      speed: "Medium",
      bestFitStyle: "operational",
    },
  },
  {
    id: "commercial-conversion",
    title: "Commercial Conversion",
    shortTitle: "Commercial Conversion",
    subtitle: "Create value by converting commercial property to residential use",
    details: ["Significant value uplift potential", "Planning and use-class advantage", "Undervalued asset opportunities"],
    stats: {
      cashflow: "Low",
      equity: "High",
      complexity: "High",
      builderHeavy: "Yes",
      speed: "Slow",
      bestFitStyle: "heavy-execution",
    },
  },
  {
    id: "flips",
    title: "Flips (Buy, Refurbish, Sell)",
    shortTitle: "Flips",
    subtitle: "Generate short-term profit by adding value and selling",
    details: ["Capital recycling", "No long-term tenant management", "Profit realised on sale"],
    stats: {
      cashflow: "Low",
      equity: "High",
      complexity: "High",
      builderHeavy: "Yes",
      speed: "Fast",
      bestFitStyle: "heavy-execution",
    },
  },
]

export function normalizeOperatingPreference(value) {
  return LEGACY_OPERATING_STYLES[value] || value || ""
}
